









































import Vue from 'vue'
export default Vue.extend({
	props: {
		index: Number,
		enStyle: Boolean
	}
})
